import {
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField
} from "@mui/material";
import { styled } from "@mui/system";
import { useEffect } from "react";
import { NumericFormat } from "react-number-format";

const StyledTextField = styled(TextField)({
  minWidth: "80px",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#E9EAEC",
    borderRadius: "10px"
  },
  "& .MuiInputBase-root.Mui-disabled": {
    backgroundColor: "rgb(255, 255, 255)",
    borderColor: "rgb(179, 179, 179)",
    outline: "none",
    "& fieldset": {
      borderColor: "rgb(179, 179, 179)",
      borderWidth: "0.5px"
    }
  }
});

export const Section5 = ({
  formState,
  handleChange,
  handleSectionComplete,
  reportId,
  isEditingEnabled
}) => {
  useEffect(() => {
    const categories = [
      "pastors",
      "evangelists",
      "teachers",
      "missionaries",
      "unordainedServants"
    ];

    // Calculate all totals in one go to batch the updates
    const updates = categories.reduce((acc, category) => {
      const male = Number(formState.pastoralTraining[category].male) || 0;
      const female = Number(formState.pastoralTraining[category].female) || 0;
      const total = male + female;

      if (total !== formState.pastoralTraining[category].total) {
        acc[category] = {
          ...formState.pastoralTraining[category],
          total
        };
      }
      return acc;
    }, {});

    // Only update if there are changes
    if (Object.keys(updates).length > 0) {
      handleChange("pastoralTraining", "all", updates);
    }
  }, [
    formState.pastoralTraining.pastors.male,
    formState.pastoralTraining.pastors.female,
    formState.pastoralTraining.evangelists.male,
    formState.pastoralTraining.evangelists.female,
    formState.pastoralTraining.teachers.male,
    formState.pastoralTraining.teachers.female,
    formState.pastoralTraining.missionaries.male,
    formState.pastoralTraining.missionaries.female,
    formState.pastoralTraining.unordainedServants.male,
    formState.pastoralTraining.unordainedServants.female
  ]);

  return (
    <Stack spacing={2}>
      <TableContainer sx={{ overflowX: "auto" }}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell></TableCell>
              <TableCell align="center">ወንድ</TableCell>
              <TableCell align="center">ሴት</TableCell>
              <TableCell align="center">ድምር</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                አገልጋዮችን የማብቃት ት/ት በመማር ላይ ያሉ አገልጋዮች መጋቢያን ብዛት
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.pastoralTraining.pastors.male}
                  onValueChange={values => {
                    handleChange("pastoralTraining", "pastors", {
                      ...formState.pastoralTraining.pastors,
                      male: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.pastoralTraining.pastors.female}
                  onValueChange={values => {
                    handleChange("pastoralTraining", "pastors", {
                      ...formState.pastoralTraining.pastors,
                      female: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.pastoralTraining.pastors.total}
                  inputProps={{
                    readOnly: true
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                አገልጋዮችን የማብቃት ት/ት በመማር ላይ ያሉ አገልጋዮች ወንጌላውያን ብዛት
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.pastoralTraining.evangelists.male}
                  onValueChange={values => {
                    handleChange("pastoralTraining", "evangelists", {
                      ...formState.pastoralTraining.evangelists,
                      male: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.pastoralTraining.evangelists.female}
                  onValueChange={values => {
                    handleChange("pastoralTraining", "evangelists", {
                      ...formState.pastoralTraining.evangelists,
                      female: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.pastoralTraining.evangelists.total}
                  inputProps={{
                    readOnly: true
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                አገልጋዮችን የማብቃት ት/ት በመማር ላይ ያሉ አገልጋዮች መምህራን ብዛት
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.pastoralTraining.teachers.male}
                  onValueChange={values => {
                    handleChange("pastoralTraining", "teachers", {
                      ...formState.pastoralTraining.teachers,
                      male: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.pastoralTraining.teachers.female}
                  onValueChange={values => {
                    handleChange("pastoralTraining", "teachers", {
                      ...formState.pastoralTraining.teachers,
                      female: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.pastoralTraining.teachers.total}
                  inputProps={{
                    readOnly: true
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                አገልጋዮችን የማብቃት ት/ት በመማር ላይ ያሉ አገልጋዮች ያሲዮናውያን ብዛት
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.pastoralTraining.missionaries.male}
                  onValueChange={values => {
                    handleChange("pastoralTraining", "missionaries", {
                      ...formState.pastoralTraining.missionaries,
                      male: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.pastoralTraining.missionaries.female}
                  onValueChange={values => {
                    handleChange("pastoralTraining", "missionaries", {
                      ...formState.pastoralTraining.missionaries,
                      female: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.pastoralTraining.missionaries.total}
                  inputProps={{
                    readOnly: true
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                አገልጋዮችን የማብቃት ት/ት በመማር ላይ ያሉ አገልጋዮች ያልተሾሙ አገልጋዮች ብዛት
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.pastoralTraining.unordainedServants.male}
                  onValueChange={values => {
                    handleChange("pastoralTraining", "unordainedServants", {
                      ...formState.pastoralTraining.unordainedServants,
                      male: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.pastoralTraining.unordainedServants.female}
                  onValueChange={values => {
                    handleChange("pastoralTraining", "unordainedServants", {
                      ...formState.pastoralTraining.unordainedServants,
                      female: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.pastoralTraining.unordainedServants.total}
                  inputProps={{
                    readOnly: true
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      {!reportId && (
        <Stack alignItems="flex-start">
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleSectionComplete(6)}
          >
            ቀጥል
          </Button>
        </Stack>
      )}
    </Stack>
  );
};
